module.exports = __webpack_public_path__ + "img/comment_dark.0cff248b.svg";